var cov_211xw13oeo = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/Flow.tsx",
      hash = "290f213efa61abc0abcba1b0c9d90c527f79b13a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/Flow.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 16
        }
      },
      "1": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 45
        }
      },
      "2": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 20
        }
      },
      "3": {
        start: {
          line: 17,
          column: 33
        },
        end: {
          line: 17,
          column: 43
        }
      },
      "4": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "5": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 23,
          column: 8
        }
      },
      "6": {
        start: {
          line: 20,
          column: 19
        },
        end: {
          line: 20,
          column: 37
        }
      },
      "7": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 44
        }
      },
      "8": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 28
        }
      },
      "9": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 52
        }
      },
      "10": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 36
        }
      },
      "11": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 32
        }
      },
      "12": {
        start: {
          line: 32,
          column: 26
        },
        end: {
          line: 32,
          column: 36
        }
      },
      "13": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 54
        }
      },
      "14": {
        start: {
          line: 33,
          column: 29
        },
        end: {
          line: 33,
          column: 53
        }
      },
      "15": {
        start: {
          line: 37,
          column: 36
        },
        end: {
          line: 37,
          column: 46
        }
      },
      "16": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 60
        }
      },
      "17": {
        start: {
          line: 39,
          column: 26
        },
        end: {
          line: 39,
          column: 60
        }
      },
      "18": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 32
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 20
          },
          end: {
            line: 19,
            column: 21
          }
        },
        loc: {
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 23,
            column: 7
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        loc: {
          start: {
            line: 30,
            column: 25
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 30
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 33,
            column: 24
          },
          end: {
            line: 33,
            column: 25
          }
        },
        loc: {
          start: {
            line: 33,
            column: 29
          },
          end: {
            line: 33,
            column: 53
          }
        },
        line: 33
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        loc: {
          start: {
            line: 36,
            column: 11
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 36
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }, {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 60
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 60
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 39,
            column: 33
          },
          end: {
            line: 39,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 33
          },
          end: {
            line: 39,
            column: 52
          }
        }, {
          start: {
            line: 39,
            column: 56
          },
          end: {
            line: 39,
            column: 60
          }
        }],
        line: 39
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { Component } from '../component';
import { changeSubscribe, CHANGE_TOPIC } from '../Datum/types';
import { isFunc } from '../utils/is';

var Flow =
/*#__PURE__*/
function (_Component) {
  _inherits(Flow, _Component);

  var _super = _createSuper2(Flow);

  function Flow(props) {
    var _this;

    _classCallCheck(this, Flow);

    cov_211xw13oeo.f[0]++;
    cov_211xw13oeo.s[0]++;
    _this = _super.call(this, props);
    _this.update = void 0;
    _this.events = void 0;
    cov_211xw13oeo.s[1]++;
    _this.update = _this.forceUpdate.bind(_assertThisInitialized(_this));
    cov_211xw13oeo.s[2]++;
    _this.events = [];

    var _ref = (cov_211xw13oeo.s[3]++, _this.props),
        names = _ref.names,
        formDatum = _ref.formDatum;

    cov_211xw13oeo.s[4]++;

    if (names) {
      cov_211xw13oeo.b[0][0]++;
      cov_211xw13oeo.s[5]++;
      names.forEach(function (n) {
        cov_211xw13oeo.f[1]++;
        var nc = (cov_211xw13oeo.s[6]++, changeSubscribe(n));
        cov_211xw13oeo.s[7]++;
        formDatum.subscribe(nc, _this.update);
        cov_211xw13oeo.s[8]++;

        _this.events.push(nc);
      });
    } else {
      cov_211xw13oeo.b[0][1]++;
      cov_211xw13oeo.s[9]++;
      formDatum.subscribe(CHANGE_TOPIC, _this.update);
      cov_211xw13oeo.s[10]++;

      _this.events.push(CHANGE_TOPIC);
    }

    return _this;
  }

  _createClass(Flow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_211xw13oeo.f[2]++;
      cov_211xw13oeo.s[11]++;

      _get(_getPrototypeOf(Flow.prototype), "componentWillUnmount", this).call(this);

      var _ref2 = (cov_211xw13oeo.s[12]++, this.props),
          formDatum = _ref2.formDatum;

      cov_211xw13oeo.s[13]++;
      this.events.forEach(function (n) {
        cov_211xw13oeo.f[3]++;
        cov_211xw13oeo.s[14]++;
        return formDatum.unsubscribe(n);
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_211xw13oeo.f[4]++;

      var _ref3 = (cov_211xw13oeo.s[15]++, this.props),
          children = _ref3.children,
          formDatum = _ref3.formDatum;

      cov_211xw13oeo.s[16]++;

      if (isFunc(children)) {
        cov_211xw13oeo.b[1][0]++;
        cov_211xw13oeo.s[17]++;
        return (cov_211xw13oeo.b[2][0]++, children(formDatum)) || (cov_211xw13oeo.b[2][1]++, null);
      } else {
        cov_211xw13oeo.b[1][1]++;
      }

      cov_211xw13oeo.s[18]++;
      return children;
    }
  }]);

  return Flow;
}(Component);

export default Flow;